import { render, staticRenderFns } from "./facebook-connect-button.vue?vue&type=template&id=f896caee&scoped=true"
import script from "./facebook-connect-button.vue?vue&type=script&lang=js"
export * from "./facebook-connect-button.vue?vue&type=script&lang=js"
import style0 from "./facebook-connect-button.vue?vue&type=style&index=0&id=f896caee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f896caee",
  null
  
)

export default component.exports